import axios from "axios";
import config from "../config";
import { getAccessToken, isTokenValid, refreshAccessToken, clearSession } from "./tokenService";

const api = axios.create({
  baseURL: config.apiUrl
});

const golfApi = axios.create({
  baseURL: config.golfApiUrl
});

// Shared JWT interceptor for both API instances
function createAuthInterceptor() {
    return async (reqConfig) => {
        let token = getAccessToken();

        if (token) {
            if (!isTokenValid(token)) {
                // Access token expired -> refresh via the HttpOnly refresh cookie (single-flight).
                token = await refreshAccessToken();
                if (!token) {
                    clearSession();
                    window.location.href = '/login';
                    return Promise.reject(new Error("Unable to refresh token, please log in again"));
                }
            }

            reqConfig.headers = {
                ...reqConfig.headers,
                Authorization: `Bearer ${token}`
            };
        }

        return reqConfig;
    };
}

const errorHandler = (error) => Promise.reject(error);
api.interceptors.request.use(createAuthInterceptor(), errorHandler);
golfApi.interceptors.request.use(createAuthInterceptor(), errorHandler);

export { golfApi };
export default api;
